﻿import creator from '../elementCreator';
import globals from '../globals';
import Style from 'ol/style/Style.js';
import Stroke from 'ol/style/Stroke.js';
import Fill from 'ol/style/Fill.js';
import Text from 'ol/style/Text.js';
import Circle from 'ol/style/Circle.js';
import Draw from 'ol/interaction/Draw.js';
import Select from 'ol/interaction/Select.js';
import Modify from 'ol/interaction/Modify.js';
import Vector from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import {click} from 'ol/events/condition.js';
import WKT from 'ol/format/WKT.js';

"use strict";

var privateFns, mapInteractions, clickFns, parameters;
parameters = {
	deactivatefunctions: [],
	lastClick: "",
	selectedColor: "black",
	interactions: {},
	geometryType: "",
}

mapInteractions = {
	getActiveInteractions: function () {
		var interactions = {};
		globals.map.getInteractions().forEach(function (i) {
			if (i.get("itype") === "draw") {
				interactions.measureInteraction = i;
			} else if (i.get("interactionId") === "featurehover") {
				interactions.mapHoverInteraction = i;
			} else if (i.get("featurehover") === "featureclick") {
				interactions.mapClickInteraction = i;
			}
		});
		return interactions;
	},
	addSelectInteraction: function () {
		var vector = globals.map.getLayerByName("sketchLayer");
			//global.map.removeInteraction(mapInteractions.getActiveInteractions().measureInteraction);
		var source = undefined;
		if (vector === null) {
			source = mapInteractions.addDrawLayer();
		} else {
			source = vector.getSource();
		}
		var select = new Select({
			condition: click,
			source: source,
			id: "select",
		});
		select.on('select', function(e){
			e.selected.forEach(function(lyr){
				//Setter linja til gjennomsiktig før den blir fjernet når kartet oppdateres neste gang.
				if(lyr){
					lyr.style_(lyr)[0].stroke_.color_ = "rgba(255, 0, 0, 0)";
					lyr.changed();
					source.removeFeature(lyr);						
				}
			});
		});
		var editSelect = new Select({
			condition: click,
			source: source,
			interactionId: "editSelect",
		});
		editSelect.on('select', function(e){
			e.selected.forEach(function(lyr){
				if(lyr){
					lyr.style = privateFns.styleFunction();
					lyr.changed();					
				}
			});
		});
		parameters.interactions.trashSelectInteraction = select;
		parameters.interactions.editSelectInteraction = editSelect;
		select.setActive(false);
		editSelect.setActive(false);
		globals.map.addInteraction(select);
		globals.map.addInteraction(editSelect);
	},
	addPointerIcon: function () {
		var source = new VectorSource();
		var iconStyle = new Style({
		  text: new Text({
			text: "				" + String.fromCodePoint('0xf040'),
			font: 'normal 18px icomoon, FontAwesome',
			textBaseline: 'right',
			fill: new Fill({
			  color: "var(--main)",
			}),
		  }),
		});
		var draw = new Draw({
			source: source,
			type: "Point",
			style: iconStyle,
			interactionId: "pointerIcon",
		});
		draw.set("itype", "draw");
		draw.set("style", iconStyle);
		parameters.interactions.pointerIcon = draw;
		globals.map.addInteraction(draw);
		return source;
	},
	addDrawInteraction: function (type) {
		var vector = globals.map.getLayerByName("sketchLayer");
		var source = undefined;
		if (vector === null) {
			source = mapInteractions.addDrawLayer();
		} else {
			source = vector.getSource();
		}
		var draw = new Draw({
			source: source,
			type: type,
		});
		draw.set("itype", "draw");
		draw.on('drawend', function(event){
			var feature = event.feature;
			var style = new Style({
				stroke: new Stroke({
					color: parameters.selectedColor,
					width: $('input[name="size"]:checked').val(),
				}),
				image: new Circle({
					radius: 5,
					stroke: new Stroke({
						color: "rgba(255, 0, 0, 1)"
					}),
					fill: new Fill({
						color: "rgba(255, 255, 255, 0.2)"
					})
				})
			});
			feature.setStyle(style);
			feature.changed();
		});
		parameters.interactions.measureInteraction = draw;
		globals.map.addInteraction(draw);
	},
	addModifyInteraction: function(){
		const modify = new Modify({
			source: globals.map.getLayerByName("sketchLayer").getSource(),
			style: privateFns.styleFunction(),
			interactionId: "editInteraction",
			insertVertexCondition: function () {
				// prevent new vertices to be added to the polygons
				return !parameters.interactions.editSelectInteraction
				.getFeatures()
				.getArray()
				.every(function (feature) {
					return feature
					.getGeometry()
					.getType()
					.match(/Polygon/);
				});
			},
		});
		parameters.interactions.modifyInteraction = modify;
		modify.setActive(false);
		globals.map.addInteraction(modify);
	},
	addScaleInteraction: function(){
		const modify = new Modify({
			source: globals.map.getLayerByName("sketchLayer").getSource(),
			style: function (modifyGeometry) {
					//const modifyGeometry = feature.get('modifyGeometry');
					if (modifyGeometry) {
						const point = modifyGeometry.getGeometry().getCoordinates();
						let modifyPoint = modifyGeometry.point;
						if (!modifyPoint) {
							// save the initial geometry and vertex position
							modifyPoint = point;
							modifyGeometry.point = modifyPoint;
							modifyGeometry.geometry0 = modifyGeometry.geometry;
							// get anchor and minimum radius of vertices to be used
							const result = mapInteractions.calculateCenter(modifyGeometry.getGeometry());
							modifyGeometry.center = result.center;
							modifyGeometry.minRadius = result.minRadius;
						}
						const center = modifyGeometry.center;
						const minRadius = modifyGeometry.minRadius;
						let dx, dy;
						dx = modifyPoint[0] - center[0];
						dy = modifyPoint[1] - center[1];
						const initialRadius = Math.sqrt(dx * dx + dy * dy);
						if (initialRadius > minRadius) {
							const initialAngle = Math.atan2(dy, dx);
							dx = point[0] - center[0];
							dy = point[1] - center[1];
							const currentRadius = Math.sqrt(dx * dx + dy * dy);
							if (currentRadius > 0) {
								const currentAngle = Math.atan2(dy, dx);
								const geometry = modifyGeometry.geometry0.clone();
								geometry.scale(currentRadius / initialRadius, undefined, center);
								//geometry.rotate(currentAngle - initialAngle, center);
								modifyGeometry.geometry = geometry;
							}
						}
					}
				return mapInteractions.defaultStyle(modifyGeometry);
			},
			interactionId: "scaleRotateInteraction",
			insertVertexCondition: function () {
				// prevent new vertices to be added to the polygons
				return !parameters.interactions.editSelectInteraction
				.getFeatures()
				.getArray()
				.every(function (feature) {
					return feature
					.getGeometry()
					.getType()
					.match(/Polygon/);
				});
			},
		});
		parameters.interactions.scaleRotateInteraction = modify;
		modify.setActive(false);
		modify.on('modifystart', function (event) {
			event.features.forEach(function (feature) {
				feature.set(
					'modifyGeometry',
					{geometry: feature.getGeometry().clone()},
					true
				);
			});
		});

		modify.on('modifyend', function (event) {
			event.features.forEach(function (feature) {
				const modifyGeometry = feature.get('modifyGeometry');
				if (modifyGeometry) {
					feature.setGeometry(modifyGeometry.geometry);
					feature.unset('modifyGeometry', true);
				}
			});
		});
		
		globals.map.addInteraction(modify);
		
	},
	calculateCenter: function(geometry) {
		let center, coordinates, minRadius;
		const type = geometry.getType();
		if (type === 'Polygon') {
			let x = 0;
			let y = 0;
			let i = 0;
			coordinates = geometry.getCoordinates()[0].slice(1);
			coordinates.forEach(function (coordinate) {
				x += coordinate[0];
				y += coordinate[1];
				i++;
			});
			center = [x / i, y / i];
		} else if (type === 'LineString') {
			center = geometry.getCoordinateAt(0.5);
			coordinates = geometry.getCoordinates();
		} else {
			center = getCenter(geometry.getExtent());
		}
		let sqDistances;
		if (coordinates) {
			sqDistances = coordinates.map(function (coordinate) {
				const dx = coordinate[0] - center[0];
				const dy = coordinate[1] - center[1];
				return dx * dx + dy * dy;
			});
			minRadius = Math.sqrt(Math.max.apply(Math, sqDistances)) / 3;
		} else {
			minRadius =
			Math.max(
				getWidth(geometry.getExtent()),
				getHeight(geometry.getExtent())
			) / 3;
		}
		return {
			center: center,
			coordinates: coordinates,
			minRadius: minRadius,
			sqDistances: sqDistances,
		};
	},
	defaultStyle: function (){
		return new Style({
			geometry: function (feature) {
				const modifyGeometry = feature.get('modifyGeometry');
				return modifyGeometry ? modifyGeometry.geometry : feature.getGeometry();
			},
			fill: new Fill({
				color: 'rgba(255, 255, 255, 0.2)',
			}),
			stroke: new Stroke({
				color: '#ffcc33',
				width: 2,
			}),
			image: new Circle({
				radius: 7,
				fill: new Fill({
					color: '#ffcc33',
				}),
			}),
		});
	},
	addDrawLayer: function () {
		var style = new Style({
			stroke: new Stroke({
				color: "#ff0000",
				width: 3
			}),
			image: new Circle({
				radius: 5,
				stroke: new Stroke({
					color: "rgba(255, 0, 0, 1)"
				}),
				fill: new Fill({
					color: "rgba(255, 255, 255, 0.2)"
				})
			})
		});
		var source = new VectorSource();
		var vector = new Vector({
			title: "sketchLayer",
			layerId: "sketchLayer",
			source: source,
			style: style,
			zIndex: 1000,
		});
		globals.map.addLayer(vector);
		return source;
	},
	addMeasureInteraction: function (type) {
		var dstyleCache = {};
		var vector = globals.map.getLayerByName("drawLayer");
		var source = undefined;
		if (vector === null) {
			source = mapInteractions.addMeasureLayer();
		} else {
			source = vector.getSource();
		}

		var draw = new Draw({
			source: source,
			type: type,
			style: function (feature) {
				var size = 0;
				if (feature.getGeometry().getType() === "LineString" && type === "LineString") {
					size = mapInteractions.getMeasureLength(feature);
				} else if (feature.getGeometry().getType() === "Polygon" && type === "Polygon") {
					size = mapInteractions.getMeasureArea(feature);
				} else { 
					  size = "";
				}
				var style = dstyleCache[size];
				if (!style) {
					style = [new Style({
						fill: new Fill({
							color: "rgba(255, 255, 255, 0.2)"
						}),
						stroke: new Stroke({
							color: "rgba(0, 0, 255, 1)",
							lineDash: [10, 10],
							width: 2
						}),
						text: new Text({
							scale: 2.0,
							text: size.toString(),
							fill: new Fill({
								color: "#fff"
							}),
							stroke: new Stroke({
								color: "#00f",
								width: 2
							}),
							overflow: true,
						}),
						image: new Circle({
							radius: 5,
							stroke: new Stroke({
								color: "rgba(0, 0, 255, 1)"
							}),
							fill: new Fill({
								color: "rgba(255, 255, 255, 0.2)"
							})
						})
					})];
					dstyleCache[size] = style;
				}
				return style;
			}
		});
		draw.set("itype", "draw");
		parameters.interactions.measureInteraction = draw;
		globals.map.addInteraction(draw);
	},
	addMeasureLayer: function () {
		var vstyleCache = {};
		var source = new VectorSource();
		var layer = new Vector({
			title: "drawLayer",
			layerId: "drawLayer",
			source: source,
			style: function (feature) {
				var size = 0;
				if (feature.getGeometry().getType() === "LineString") {
					size = mapInteractions.getMeasureLength(feature);
				} else {
					size = mapInteractions.getMeasureArea(feature);
				}
				var style = vstyleCache[size];
				if (!style) {
					style = [new Style({
						fill: new Fill({
							color: "rgba(255, 255, 255, 0.2)"
						}),
						stroke: new Stroke({
							color: "#0000ff",
							width: 3
						}),
						text: new Text({
							scale: 2.0,
							text: size.toString(),
							fill: new Fill({
								color: "#fff"
							}),
							stroke: new Stroke({
								color: "#00f",
								width: 2
							}),
							overflow: true,
							textAlign: "end"
						})
					})];
					vstyleCache[size] = style;
				}
				return style;
			}
		});
		layer.setZIndex(10000);
		globals.map.addLayer(layer);
		return source;
	},
	getMeasureLength: function (feature) {
		var size = feature.getGeometry().getLength();
		var distance = 0;
		if (size > 10000) {
			distance = (Math.round(size / 1000 * 100) / 100) + " " + "km";
		} else if(size > 1000){
			distance = Math.round(size) + " " + "m";
		}else {
			distance = Math.round(size*10)/10 + " " + "m";
		}
		return distance;
	},
	getMeasureArea: function (feature) {
		var size = feature.getGeometry().getArea();
		var area = 0;
		if (size > 1000000) {
			area = (Math.round(size / 1000000 * 100) / 100) + " km²";
		} else {
			area = Math.round(size) + " " + "m²";
		}
		return area;
	},
	deactivateMapTools: function (id) {
		$("button.selected").each(function (idx, btn) {
			if (btn.id !== id && btn.id !== "map-wrench" && idx >= 0) {
				var button = $("#"+btn.id);
				if(!privateFns.handler(button)){
					if(button[0].deactivate){
						button[0].deactivate();
					}
				}
			}
		});
	},
},
clickFns = {
	zoomFullClick: function(e){
		globals.map.getView().fit(
			[567333, 6628570, 621043, 6670440],
			globals.map.getSize()
		);
		$(e.currentTarget).blur();
	},
	eraserClick: function(e){
		globals.clearMap(e);
	},
	goToClick: function(){
		var btn = $("#go-to-location");
		btn.addClass("map-tool-btn-busy");
		btn.prop("disabled", true);
		btn.find("i").removeClass("fa-crosshairs").addClass("fa-spinner fa-pulse");
		if (globals.map.getLayerById("geoloclayer") === null) {
			var geoLocLayer = new ol.layer.Vector({
				title: "GeoLocLayer",
				layerId: "geoloclayer",
				group: "hidden",
				source: new ol.source.Vector({features: []}),
				opacity: 0.9,
				style: new ol.style.Style({
					image: new ol.style.Icon({
						scale: 1,
						src: 'https://od2.pbe.oslo.kommune.no/kart/icons/Kart PinBlue.svg'
					}),
				})
			});
			globals.map.addLayer(geoLocLayer);
		}

		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				privateFns.showPosition,
				privateFns.showError,
				{
					enableHighAccuracy: true,
					timeout: 14000,
					maximumAge: 60000
				}
			);
		} else {
			console.log("Geolocation not supported");
		}
		btn.blur();
	},
	multiSearch: function(e){
		var btn = $(e.currentTarget);
		btn.toggleClass("selected");
		if (!$(e.currentTarget)[0].classList.contains("selected")) {
			globals.multiEiendom = false;
		} else {
			globals.multiEiendom = true;
		}
	},
	measureLengthClick: function (e) {
		var btn = $(e.currentTarget);
		privateFns.deactivateAll(btn.attr("id"));
		if ($("button.selected").length > 0 ) {
			mapInteractions.deactivateMapTools(btn.attr("id"));
		}
		privateFns.handler(btn);
	},
	measureAreaClick: function (e) {
		var btn = $(e.currentTarget);
		privateFns.deactivateAll(btn.attr("id"));
		if ($("button.selected").length > 0 ) {
			mapInteractions.deactivateMapTools(btn.attr("id"));
		}
		privateFns.handler(btn);
	},
	drawClick: function (e) {
		var btn = $(e.currentTarget);
		privateFns.deactivateAll(btn.attr("id"));
		if ($("button.selected").length > 0 ) {
			mapInteractions.deactivateMapTools(btn.attr("id"));
		}
		privateFns.handler(btn);
	},
};
privateFns = {
	pluginHandler: function(btn, onclickFunc){
		if ($("button.selected").length > 0 ) {
			mapInteractions.deactivateMapTools(btn.attr("id"));
		}
		onclickFunc();
	},
	handler: function(btn){
		var id = btn.attr("id");
		var className = btn.attr("class");
		btn.toggleClass("selected");
		var interactions = mapInteractions.getActiveInteractions();
		var toolTipWin = undefined, showWin = undefined;
		
		toolTipWin = $("#"+btn.attr("id") + "-tool-help");
		showWin = localStorage.getItem("planinnsyn-"+btn.attr("id"));
		if (interactions.measureInteraction) {
			// Slår av måle-/tegneverktøy
			toolTipWin.hide();
			$("#map-draw-panel").hide();
			globals.map.removeInteraction(interactions.measureInteraction);

			globals.mapclick = true;
			
			if (interactions.mapClickInteraction) {
				interactions.mapClickInteraction.setActive(true);
			}
			if(interactions.mapHoverInteraction){					
				interactions.mapHoverInteraction.setActive(true);
			}
			if(parameters.interactions.pointerIcon){
				parameters.interactions.pointerIcon.setActive(false);
				parameters.interactions.trashSelectInteraction.setActive(false);
				$('#removeBtn').removeClass("activeTool");
			}
			btn.removeClass("selected");
			btn.blur();
			return true;
		} else {
			// Slår på måle-/tegneverktøy
			if (toolTipWin.is(":visible") === false) {
				if(showWin === null){
					toolTipWin.show();
				}
				if(!showWin){
					toolTipWin.show();
				}
			}
			if (interactions.mapClickInteraction) {
				interactions.mapClickInteraction.setActive(false);
			}
			if(interactions.mapHoverInteraction){				
				interactions.mapHoverInteraction.setActive(false);
			}
			globals.mapclick = false;
			if (className.indexOf("area-btn") >= 0) {
				mapInteractions.addMeasureInteraction("Polygon");
			} else if (className.indexOf("length-btn") >= 0) {
				mapInteractions.addMeasureInteraction("LineString");
			} else if (className.indexOf("sketch-btn") >= 0) {
				var panel = $("#map-draw-panel");
				if(panel[0]){
					panel.show();
				}else{
					privateFns.addDrawControlPanel();
				}
				mapInteractions.addDrawInteraction("LineString");
			} else {
				return false;
				console.error("Ukjent måleverktøyknapp: " + id);
			}
			return true;
		}
	},
	registerClearLayer: function(clearLayers){
		clearLayers.forEach(function(l){
			globals.clearLayers.push(l);
		});
	},
	registerPlugin: function(plug, callback){
		var deactivateFunc = {};
		deactivateFunc.id = plug.id; 
		deactivateFunc.func = plug.deactivate;
		parameters.deactivatefunctions.push(deactivateFunc);
		if(plug.clear){
			privateFns.registerClearLayer(plug.clear);				
		};
		globals.registeredPlugins[plug.id] = plug;
		if(plug.GIFunctions){
			Object.keys(plug.GIFunctions).forEach(function(func){
				globals.GIFunctions[func] = plug.GIFunctions[func];
			});
		}
		if(plug.onclick){
			clickFns[plug.onclick.name] = plug.onclick;
		}
		if(callback){
			callback();
		};
		//Legger til info om verktøy som er registrert etter at info menyen er laget.
		if(document.getElementById("toolArticle") && plug.userGuide && !document.getElementById("tool-info-" + plug.id)){
			var row  = creator.createDiv({id: "tool-info" + plug.id, css: "help-topic-tool-row"});
			var img  = creator.createDiv({css: "help-topic-tool-img"});
			var desc = creator.createDiv({css: "help-topic-tool-desc"});
			
			row.innerHTML = "";
			img.innerHTML = "";
			
			if(plug.userGuide.img.type === "icon"){
				img.innerHTML = '<span class= "' + plug.userGuide.img.className + '"></span>';
			}
			desc.innerHTML = plug.userGuide.text;
			row.appendChild(img);
			row.appendChild(desc);
			row.className += plug.userGuide.className ? " " +plug.userGuide.className : "";
			toolArticle.appendChild(row);
		}
	},
	registerAreaMeasurePlugin: function(registerFunction, callback){
		var areaPlugin = {
			id: "measure-area-small",
			deactivate: mapInteractions.deactivateMapTools,
			clear: ["drawLayer"],
			share: privateFns.createMeasureLink,
			handler: privateFns.handleMeasure,
			onclick: "measureAreaClick",
			userGuide:{
				img: {type: "text", className: "m²"},
				text: "Mål areal. Klikk i kartet til det blå omrisset dekker arealet du ønsker å måle. Dobbeltklikk for å avslutte. Hold inne shift for å måle på frihånd. Slå av verktøyet ved å klikke på knappen igjen.",
			},
		};
		privateFns.registerPlugin(areaPlugin, callback)
	},
	registerLengthMeasurePlugin: function(registerFunction, callback){
		var lengthPlugin = {
			id: "measure-length-small",
			deactivate: mapInteractions.deactivateMapTools,
			clear: ["drawLayer"],
			share: privateFns.createMeasureLink,
			handler: privateFns.handleMeasure,
			onclick: "measureLengthClick",
			userGuide:{
				img: {type: "icon", className: "icon-measure"},
				text: "Mål avstand. Klikk i punktet du ønsker å måle fra, klikk deretter for å legge inn knekkpunkter eller dobbeltklikk for å avslutte måling. Hold inne 'shift' for å måle på frihånd. Slå av verktøyet ved å klikke på knappen igjen.",
			},
		};
		privateFns.registerPlugin(lengthPlugin, callback)
	},
	registerDrawPlugin: function(registerFunction, callback){
		var drawPlugin = {
				id: "makeSketchSmall",
				deactivate: mapInteractions.deactivateMapTools,
				clear: ["sketchLayer"],
				share: privateFns.createDrawLink,
				handler: privateFns.handleDraw,
				onclick: "drawClick",
				userGuide:{
					img: {type: "icon", className: "fa fa-pencil"},
					text: "Tegn i kartet. Klikk i kartet for å starte tegning. Klikk et annet sted i kartet for å lage en linje. Dobbelklikk for å avslutte tegning. Hold inne shift for å tegne frihånd. Bruk redigeringsknappen for å flytte linjer.",
				},
			};
		privateFns.registerPlugin(drawPlugin, callback)
	},
	deactivateAll: function(id){
		if(parameters.lastClick != id){				
			parameters.deactivatefunctions.forEach(function(func){
				if(func.id != id && func.func){
					func.func(id);
				}
			});
		}
		parameters.lastClick = id;
	},
	handleDraw: function(arr, reg){
		var source = mapInteractions.addDrawLayer();
		arr.forEach(function (geom) {
			var wkt = new WKT();
			//feature = wkt.readFeature(decodeURIComponent(geom));
			/* Koder om fra < og > til ( og ) i wkt-streng pga problemer med lenke delt med epost i Outlook 2010 */
			geom = geom.replace(/</g, "(");
			geom = geom.replace(/>/g, ")");
			geom = geom.split("&");
			var feature = wkt.readFeature(geom[0]);
			var style = new Style({
				stroke: new Stroke({
					color: geom[1].split("=")[1],
					width: geom[2].split("=")[1],
				}),
				image: new Circle({
					radius: 5,
					stroke: new Stroke({
						color: "rgba(255, 0, 0, 1)"
					}),
					fill: new Fill({
						color: "rgba(255, 255, 255, 0.2)"
					})
				})
			});
			feature.setStyle(style);
			source.addFeature(feature);
		});
	},
	handleMeasure: function(arr, reg){
		var source = globals.map.getLayerByName("drawLayer");
		if(!source){				
			source = mapInteractions.addMeasureLayer();
		}
		arr.forEach(function (geom) {
			var wkt = new ol.format.WKT();
			//feature = wkt.readFeature(decodeURIComponent(geom));
			/* Koder om fra < og > til ( og ) i wkt-streng pga problemer med lenke delt med epost i Outlook 2010 */
			geom = geom.replace(/</g, "(");
			geom = geom.replace(/>/g, ")");
			var feature = wkt.readFeature(geom);
			if(source.addFeature){
				source.addFeature(feature);
			}
		});
	},
	createDrawLink: function(){
		return privateFns.getLinkFromLayerFeatures(globals.map.getLayerByName("sketchLayer"), true);
	},
	createMeasureLink: function(){
		return privateFns.getLinkFromLayerFeatures(globals.map.getLayerByName("drawLayer"));
	},
	createWktString: function(layer, addStyle){
		var wktString = "";
		if(layer){
			layer.getSource().getFeatures().forEach(function (f, idx) {
				var wkt = new WKT();
				if (f.getGeometry().getType() === "LineString") {
					parameters.geometryType = "LineString";
					f.getGeometry().setCoordinates(privateFns.roundLineStringCoords(f.getGeometry().getCoordinates()));
				} else if (f.getGeometry().getType() === "Polygon") {
					parameters.geometryType = "Polygon";
					f.getGeometry().setCoordinates(privateFns.roundPolygonCoords(f.getGeometry().getCoordinates()));
				} else {
					console.error("Ugyldig geometritype: " + f.getGeometry().getType());
				}
				wktString += wkt.writeGeometry(f.getGeometry());
				if(addStyle){
					wktString += "&color=" + f.getStyle().stroke_.color_+"&width=" + f.getStyle().stroke_.width_;
				}
				if (idx < layer.getSource().getFeatures().length - 1) {
					wktString += "|";
				}
			});
		}
		return wktString;
	},
	getLinkFromLayerFeatures: function(layer, addStyle){
		if(layer){
			//legger til checkbokser i dele menyen
			if(document.getElementById("share-controls")){
				if(addStyle && !document.getElementById("draw-share-container")){
					let draw = creator.createDiv({id: "draw-share-container"});
					let drawBoks = creator.createInput({type: "checkbox", id: "drawCheckBoks"});
					drawBoks.checked = true;
					draw.appendChild(drawBoks);
					let drawBoksLabel = creator.createLabel({text: "Tegning", htmlfor: "drawCheckBoks"});
					draw.appendChild(drawBoksLabel);
					$("#share-controls").append(draw);
					drawBoks.onclick = function (e) {
						let encodedWktString = encodeURIComponent(privateFns.createWktString(layer, addStyle));
						if(e.target.checked && encodedWktString.length > 0){
							$(".permalink")[0].href = $(".permalink")[0].href + "&makeSketchSmall=" + encodedWktString;
							$(".permalink")[0].innerHTML = $(".permalink")[0].innerHTML + "&makeSketchSmall=" + encodedWktString;
						}else{
							$(".permalink")[0].href = $(".permalink")[0].href.replace("&makeSketchSmall=" + encodedWktString, "");
							$(".permalink")[0].innerHTML = $(".permalink")[0].innerHTML.replace("&amp;makeSketchSmall=" + encodedWktString, "");
						}
					};
				}
				if(!addStyle && !document.getElementById("measure-share-container")){
					let measure = creator.createDiv({});
					measure.id = "measure-share-container";
					let measureBoks = creator.createInput({type: "checkbox", id: "measureCheckBoks"});
					measureBoks.checked = true;
					measure.appendChild(measureBoks);
					let measureBoksLabel = creator.createLabel({text: "Måling", htmlfor: "measureCheckBoks"});
					measure.appendChild(measureBoksLabel);
					$("#share-controls").append(measure);
					measureBoks.onclick = function (e) {
						let encodedWktString = encodeURIComponent(privateFns.createWktString(layer, addStyle));
						if(e.target.checked && encodedWktString.length > 0){
							if(parameters.geometryType === "Polygon"){
								$(".permalink")[0].href = $(".permalink")[0].href + "&measure-area-small="+encodedWktString;
								$(".permalink")[0].innerHTML = $(".permalink")[0].href + "&measure-area-small="+encodedWktString;
							}else if(parameters.geometryType === "LineString"){
								$(".permalink")[0].href = $(".permalink")[0].href + "&measure-length-small="+encodedWktString;
								$(".permalink")[0].innerHTML = $(".permalink")[0].href + "&measure-length-small="+encodedWktString;
							}
						}else{
							$(".permalink")[0].href = $(".permalink")[0].href.replace("&measure-area-small="+encodedWktString, "").replace("&measure-length-small="+encodedWktString, "");
							$(".permalink")[0].innerHTML = $(".permalink")[0].href.replace("&measure-area-small="+encodedWktString, "");
							$(".permalink")[0].innerHTML = $(".permalink")[0].href.replace("&measure-length-small="+encodedWktString, "");
						}
					};
				}
			}
		}
		return  privateFns.createWktString(layer, addStyle);
	},
	roundLineStringCoords: function (coordinates) {
		var tmpArray = [];
		coordinates.forEach(function (c) {
			c[0] = parseFloat(c[0].toFixed(2));
			c[1] = parseFloat(c[1].toFixed(2));
			tmpArray.push(c);
		});
		return tmpArray;
	},
	roundPolygonCoords: function (coordinates) {
		var tmpArray = [];
		coordinates[0].forEach(function (c) {
			c[0] = parseFloat(c[0].toFixed(2));
			c[1] = parseFloat(c[1].toFixed(2));
			tmpArray.push(c);
		});
		return [tmpArray];
	},
	addDrawControlPanel: function(){
		var panel, clearBtn;
		panel = creator.createDiv({
			css: "map-draw-panel",
			id: "map-draw-panel",
		});
		
		mapInteractions.addSelectInteraction();
		mapInteractions.addModifyInteraction();
		mapInteractions.addPointerIcon();
		mapInteractions.addScaleInteraction();
		
		panel.appendChild(privateFns.createInfoBtn());
		panel.appendChild(privateFns.createDeleteBtn());
		panel.appendChild(privateFns.createEditBtn());
		//panel.appendChild(privateFns.createScaleBtn());
		panel.appendChild(privateFns.createColorPanel());
		panel.appendChild(privateFns.createSizePanel());
		
		document.getElementById("map").appendChild(panel);
		$("#map-draw-panel").show();
	},
	createInfoBtn: function(){
		 let infoBtn = creator.createButton({
			icon: true,
			iconClass: "icon-Informasjon",
			ariaLabel: "Info om verktøy",
			id: "slider-info-btn",
			title: "Informasjon om verktøy",
			onclick: function(evt){
				$("#planinnsyn-hjelp").click();
				$("#tool-info-btn").click();
			}
		});
		infoBtn.style.float = "right";
		 return infoBtn;
	},
	createDeleteBtn: function(){
		var clearBtn = creator.createButton({
			icon: true,
			iconClass: "fa fa-trash",
			ariaLabel: "Fjern tegning",
			id: "removeBtn",
			title: "Fjern tegning",
			onclick: function(evt){
				let btn = $(evt.target);
				if(btn.prop("nodeName") === "I"){
					btn = btn.parent();
				}
				if(btn.hasClass('activeTool')){
					btn.removeClass("activeTool");
					Object.entries(parameters.interactions).forEach(function(key, value){
						parameters.interactions[key[0]].setActive(false);
					});
					parameters.interactions.measureInteraction.setActive(true);
					parameters.interactions.pointerIcon.setActive(true);
					parameters.interactions.pointerIcon.values_.style.text_.text_ = "\t\t\t\t" + String.fromCodePoint('0xf040');
				}else{
					if(document.getElementsByClassName("activeTool").namedItem("editBtn")){
						$("#editBtn").removeClass("activeTool");
					};
					btn.addClass("activeTool");
					Object.entries(parameters.interactions).forEach(function(key, value){
						parameters.interactions[key[0]].setActive(false);
					});
					parameters.interactions.pointerIcon.setActive(true);
					parameters.interactions.trashSelectInteraction.setActive(true);
					parameters.interactions.pointerIcon.values_.style.text_.text_ = "\t\t\t\t" + String.fromCodePoint('0xf1f8');
				}
				
			}
		});
		clearBtn.style.float = "right";
		return clearBtn;
	},
	createEditBtn: function(){
		var editBtn = creator.createButton({
			icon: true,
			iconClass: "fa fa-edit",
			ariaLabel: "Rediger tegning",
			id: "editBtn",
			title: "Rediger tegning",
			onclick: function(evt){
				let btn = $(evt.target);
				if(btn.prop("nodeName") === "I"){
					btn = btn.parent();
				}
				if(btn.hasClass('activeTool')){
					btn.removeClass("activeTool");
					Object.entries(parameters.interactions).forEach(function(key, value){
						parameters.interactions[key[0]].setActive(false);
					});
					parameters.interactions.measureInteraction.setActive(true);
					parameters.interactions.pointerIcon.setActive(true);
					parameters.interactions.pointerIcon.values_.style.text_.text_ = "\t\t\t\t" + String.fromCodePoint('0xf040');
				}else{
					if($("#removeBtn").hasClass("activeTool")){
						$("#removeBtn").removeClass("activeTool");
					};
					btn.addClass("activeTool");
					Object.entries(parameters.interactions).forEach(function(key, value){
						parameters.interactions[key[0]].setActive(false);
					});
					parameters.interactions.editSelectInteraction.setActive(true);
					parameters.interactions.modifyInteraction.setActive(true);
					parameters.interactions.pointerIcon.setActive(true);
					parameters.interactions.pointerIcon.values_.style.text_.text_ = "\t\t\t\t" + String.fromCodePoint('0xf044');
				}
			}
		});
		editBtn.style.float = "right";
		return editBtn;
	},
	createScaleBtn: function(){
		var scaleBtn = creator.createButton({
			icon: true,
			iconClass: "fa fa-upload",
			ariaLabel: "Skaler tegning",
			id: "scaleBtn",
			onclick: function(evt){
				let btn = $(evt.target);
				if(btn.prop("nodeName") === "I"){
					btn = btn.parent();
				}
				if(btn.hasClass('activeTool')){
					btn.removeClass("activeTool");
					Object.entries(parameters.interactions).forEach(function(key, value){
						parameters.interactions[key[0]].setActive(false);
					});
					parameters.interactions.measureInteraction.setActive(true);
					parameters.interactions.pointerIcon.setActive(true);
					parameters.interactions.pointerIcon.values_.style.text_.text_ = "\t\t\t\t" + String.fromCodePoint('0xf040');
				}else{
					if($("#removeBtn").hasClass("activeTool")){
						$("#removeBtn").removeClass("activeTool");
					};
					btn.addClass("activeTool");
					Object.entries(parameters.interactions).forEach(function(key, value){
						parameters.interactions[key[0]].setActive(false);
					});
					parameters.interactions.editSelectInteraction.setActive(true);
					parameters.interactions.scaleRotateInteraction.setActive(true);
					parameters.interactions.pointerIcon.setActive(true);
					parameters.interactions.pointerIcon.values_.style.text_.text_ = "\t\t\t\t" + String.fromCodePoint('0xf093');
				}
			}
		});
		scaleBtn.style.float = "right";
		return scaleBtn;
	},
	createColorPanel: function(){
		var colorPanel = creator.createDiv({
		});
		var textArea = creator.createDiv({
			text: "Velg farge",
			css: "color-panel"
		});
		var colorPallet = creator.createDiv({
			css: "color-pallet",
		});
		
		var btns = ["mBlaBtn", "blaBtn", "lBlaBtn", "rodBtn", "mGronnBtn", "gronnBtn", "lGronnBtn", "sortBtn", "gulBtn", "mBeigeBtn", "beigeBtn"]
		btns.forEach(function(btn){
			colorPallet.appendChild(creator.createButton({
				css: btn + " colorBtn",
				id: btn,
				onclick: function(e){
					$(".selectedBtn").removeClass("selectedBtn");
					$("#"+e.target.id).toggleClass("selectedBtn");
					parameters.selectedColor = $("#"+e.target.id).css("color");
				}
			}));
		});
		colorPanel.appendChild(textArea);
		colorPanel.appendChild(colorPallet);
		return colorPanel;
	},
	createSizePanel: function(){
		var textSizePanel = creator.createDiv({
		});
		var textArea = creator.createDiv({
			text: "Velg størrelse",
			css: "color-panel"
		});
		var sizePallet = creator.createDiv({
			css: "color-pallet",
		});
		var smallBtn = creator.createInput({
			type: "radio",
			name: "size",
			id: "small-write-btn",
			css: "size-btn-small"
		});
		smallBtn.value = "2";
		sizePallet.appendChild(smallBtn);
		var smallBtnLabel = creator.createLabel({htmlfor: "small-write-btn", text: "Liten", css: "size-label-small"});
		sizePallet.appendChild(smallBtnLabel);
		
		var medBtn = creator.createInput({
			type: "radio",
			name: "size",
			id: "medium-write-btn",
			css: "size-btn-medium"
		});
		medBtn.value = "3";
		medBtn.checked = "checked";
		sizePallet.appendChild(medBtn);
		var medBtnLabel = creator.createLabel({htmlfor: "medium-write-btn", text: "Medium", css: "size-label-medium"});
		sizePallet.appendChild(medBtnLabel);
		
		var largeBtn = creator.createInput({
			type: "radio",
			name: "size",
			id: "large-write-btn",
			css: "size-btn-large"
		});
		largeBtn.value = "5";
		sizePallet.appendChild(largeBtn);
		var largeBtnLabel = creator.createLabel({htmlfor: "large-write-btn", text: "Large", css: "size-label-large"});
		sizePallet.appendChild(largeBtnLabel);
		
		textSizePanel.appendChild(textArea);
		textSizePanel.appendChild(sizePallet);
		return textSizePanel;
	},
	styleFunction: function () {
		const styles = {};
		styles['Polygon'] = [
			new Style({
				fill: new Fill({
					color: [255, 255, 255, 0.5],
				}),
			}),
			new Style({
				stroke: new Stroke({
					color: [255, 255, 255, 1],
					width: 5,
				}),
			}),
			new Style({
				stroke: new Stroke({
					color: [0, 153, 255, 1],
					width: 3,
				}),
			}),
		];
		styles['MultiPolygon'] = styles['Polygon'];

		styles['LineString'] = [
			new Style({
				stroke: new Stroke({
					color: [255, 255, 255, 1],
					width: 5,
				}),
			}),
			new Style({
				stroke: new Stroke({
					color: [0, 153, 255, 1],
					width: 3,
				}),
			}),
		];
		styles['MultiLineString'] = styles['LineString'];

		styles['Point'] = [
			new Style({
				image: new Circle({
					radius: 7,
					fill: new Fill({
						color: [0, 153, 255, 1],
					}),
					stroke: new Stroke({
						color: [255, 255, 255, 0.75],
						width: 1.5,
					}),
				}),
				zIndex: 100000,
			}),
		];
		styles['MultiPoint'] = styles['Point'];

		styles['GeometryCollection'] = styles['Polygon'].concat(styles['Point']);

		return function (feature) {
			return styles[feature.getGeometry().getType()];
		};
	},
};

export default {
	pluginHandler: function(btn, onclickFunc){
		if ($("button.selected").length > 0 ) {
			mapInteractions.deactivateMapTools(btn.attr("id"));
		}
		onclickFunc();
	},
	toolClickFns: clickFns,
	registerClearLayer: privateFns.registerClearLayer,
	registerAreaMeasurePlugin: privateFns.registerAreaMeasurePlugin,
	registerLengthMeasurePlugin: privateFns.registerLengthMeasurePlugin,
	registerDrawPlugin: privateFns.registerDrawPlugin,
	registerPlugin: privateFns.registerPlugin,
	deactivateAll: privateFns.deactivateAll,
	deactivateMapTools: mapInteractions.deactivateMapTools,
	handleDraw: privateFns.handleDraw,
	createDrawLink: privateFns.createDrawLink,
	createMeasureLink: privateFns.createMeasureLink,
	handleMeasure: privateFns.handleMeasure,
};

